export default {
  namespaced: true,
  state: {
    companies: []
  },
  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies
    }
  },
  actions: {
    fetchCompanies({ commit }) {
      // API调用逻辑
      commit('SET_COMPANIES', [])
    }
  }
}
